import axios from "axios";
import {
	CART_ADD_ITEM,
	CART_REMOVE_ITEM,
	CART_SAVE_SHIPPING_ADDRESS,
	CART_SAVE_PAYMENT_METHOD,
	CART_ADD_CUSTOM_ITEM
} from "../constants/cartConstants";

export const addToCart = (id, qty) => async (dispatch, getState) => {
	try {
		const { data } = await axios.get(`/api/products/${id}`);

		const payload = {
			product: data._id,
			name: data.name,
			image: data.image,
			price: data.price,
			countInStock: data.countInStock,
			qty
		};

		if (qty > data.countInStock) {
			dispatch({
				type: CART_ADD_CUSTOM_ITEM,
				payload
			});
		} else {
			dispatch({
				type: CART_ADD_ITEM,
				payload
			});
		}

		// Delayed local storage update (debouncing)
		clearTimeout(getState().cart.updateTimeout);
		const timeout = setTimeout(() => {
			localStorage.setItem(
				"cartItems",
				JSON.stringify(getState().cart.cartItems)
			);
		}, 0); // Adjust the delay as needed
		dispatch({ type: "CART_UPDATE_TIMEOUT", payload: timeout });
	} catch (error) {
		console.error("Error adding to cart:", error);
	}
};

export const removeFromCart = (id) => (dispatch, getState) => {
	dispatch({
		type: CART_REMOVE_ITEM,
		payload: id
	});

	// Delayed local storage update (debouncing)
	clearTimeout(getState().cart.updateTimeout);
	const timeout = setTimeout(() => {
		localStorage.setItem(
			"cartItems",
			JSON.stringify(getState().cart.cartItems)
		);
	}, 0); // Adjust the delay as needed
	dispatch({ type: "CART_UPDATE_TIMEOUT", payload: timeout });
};

export const saveShippingAddress = (data) => (dispatch) => {
	dispatch({
		type: CART_SAVE_SHIPPING_ADDRESS,
		payload: data
	});

	localStorage.setItem("shippingAddress", JSON.stringify(data));
};

export const savePaymentMethod = (data) => (dispatch) => {
	dispatch({
		type: CART_SAVE_PAYMENT_METHOD,
		payload: data
	});

	localStorage.setItem("paymentMethod", JSON.stringify(data));
};
